{
  "de": {
    "linkShortener": {
      "hints": {
        "copied": "In Zwischenablage kopiert!",
        "shortcode": "Wir haben eine zufällige Wunsch-URL für dich generiert. Setzte hier deine Wunsch-URL"
      },
      "labels": {
        "shortcode": "Kurzlink",
        "url": "URL"
      }
    }
  }
}
